export default __webpack_public_path__ + "static/media/akinwale.e41fc8e6.png";